/**
 * PMLandlordSummaryCard — PM-facing published Landlord Verification report.
 *
 * Phase E.1 (2026-02): banner is human-selected by NTN staff and stored on
 * the pm_summary snapshot. No client-side derivation.
 */
import { Home } from "lucide-react";
import VerifiedReport from "./VerifiedReport";

function normalizeBullets(bullets = []) {
  return bullets.map((b) => ({ ...b, value: b.verified || b.claimed || "—" }));
}

export default function PMLandlordSummaryCard({ screening, testid = "pm-landlord-summary" }) {
  const summary = screening?.verifications?.landlord?.pm_summary;
  if (!summary || !summary.published_at) return null;
  const payload = {
    ...summary,
    status_banner: summary.status_banner || null,
    narrative: summary.narrative || "",
    bullets: normalizeBullets(summary.bullets),
    risk_indicators: summary.risk_indicators || [],
  };
  return (
    <VerifiedReport
      moduleName="Landlord Verification"
      title="Verified Landlord Report"
      Icon={Home}
      payload={payload}
      testid={testid}
      sectionLabel="Verified Rental History"
    />
  );
}
